<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver al listado de cortes">
            <i class="fa fa-chevron-left"></i></button>

        <button *ngIf="hasSavingAccess && !visibilitySpinnerGuardando" [disabled]="actionNotAllowed" class="btn btn-outline-success" type="button" (click)="doUpdateAforoYCorte()" title="Guardar corte/Autorización Kgs.">
            <i class="fa fa-file-o"></i> Guardar </button>

        <button *ngIf="visibilitySpinnerGuardando" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando
        </button>

        <button *ngIf="hasCreateAforoAccess && !readonly" [disabled]="disableCreateAforo" class="btn btn-outline-success btn-secondary" type="button" (click)="onCreateAforo()" title="Nuevo Aforo para el cultivo">
            <i class="fa fa-plus"></i> Nuevo Aforo para el cultivo</button>

        <div *ngIf="listaPlazosPeriodo?.Dextrio" class="nota-info">
            <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> {{ mensajeDestrio }}</label>
        </div>
    </form>
</nav>

<div class="container-fluid container-list">
    <app-inspeccion-ui-aforo-corte-edit 
        [corte]="corte" [readonly]="readonly" [fechaInicioExportacion]="fechaInicioExportacionVigente" [fechaFinPeriodo]="listaPlazosPeriodo?.PeriodoFechaFin"
        [cultivos]="cultivos" [almacenes]="almacenes" [formGroup]="formGroup" [habilitadaExportacion]="habilitadaExportacion"
        [aforosCultivos]="aforosDeCultivo"
        (cultivoSelected)="onCultivoSelected($event)" (aforoCultivoSelected)="onAforoCultivoSelected($event)"></app-inspeccion-ui-aforo-corte-edit>
</div>